import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { AppService, DialogService } from '../../../../../services'
const KEY = 'acces-dialog'
@Component({
  selector: 'atyl-acces',
  templateUrl: './acces.component.html',
  styleUrls: ['./acces.component.scss']
})

@Stringable({
  path: 'views/partials/layout/dialogs/acces-dialog',
  key: KEY,
})
export class AccesComponent extends BaseDialogComponent implements OnInit {

  @StringableValues(KEY)
  strings: any
  validate: boolean = false;
  mdp: boolean = false;
  email: any
  iddossier: any

  constructor(
    public dialogRef: MatDialogRef<AccesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private snackBar: MatSnackBar,
    dialogService: DialogService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    if (this.data.email_valid)
      this.validate = this.data.email_valid
    if (this.data.password)
      this.mdp = this.data.password
    if (this.data.email)
      this.email = this.data.email
    if (this.data.id)
      this.iddossier = this.data.id
  }

  sendValidation() {
    this.appService.sendValidationUser(this.iddossier, this.email).subscribe((res: JSONRpcResponse) => {

      this.snackBar.open(this.strings.emailSent, '', {
        duration: 3000
      })
    })
  }

  sendMDP() {
    this.appService.sendPassword(this.iddossier).subscribe((res: JSONRpcResponse) => {

      this.snackBar.open(this.strings.passwordSent, '', {
        duration: 3000,
      })

    })
  }
}
